import { render, staticRenderFns } from "./copyText.vue?vue&type=template&id=87fccc18"
import script from "./copyText.vue?vue&type=script&lang=js"
export * from "./copyText.vue?vue&type=script&lang=js"
import style0 from "./copyText.vue?vue&type=style&index=0&id=87fccc18&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports